module.exports = __webpack_public_path__ + "assets/img/https.86f3054e.svg";